import api from "api";

export const dietPlanApi = (caseId) => {
  return api.get(`dietPlan/${caseId}`);
};
